import React from 'react';
import { useTranslations } from 'next-intl';
import { UISearchBar } from '@headless-workspace/core-ui';
import { GlowClickable, GlowTextBodySmall } from '@headless-workspace/glow-ds';
import { useDeviceType } from '../../../../../../../src';
import { useSearchActionContext, useSearchStateContext } from '../provider';

export const CLEAR_SEARCH_BUTTON_ID = 'clear-search-button';

export const SearchBar = () => {
    'use memo';

    const t = useTranslations('Header.search');
    const deviceType = useDeviceType();
    const isMobile = deviceType === 'mobile';
    const { onSearch, handleOpen, onClearSearches, onSearchInputChange } = useSearchActionContext();
    const { searchInput } = useSearchStateContext();

    return (
        <UISearchBar
            placeholder={t('placeholder')}
            onSearch={onSearch}
            onFocus={handleOpen}
            clearButton={
                searchInput && (
                    <GlowClickable
                        id={CLEAR_SEARCH_BUTTON_ID}
                        className={'py-0.5'}
                        onClick={onClearSearches}
                        content={{
                            labelElement: (
                                // z-1 class is a hack to avoid the first letter to be cropped by the input
                                <GlowTextBodySmall
                                    text={t('action.clear')}
                                    textDecoration={'underline'}
                                    TagName={'span'}
                                    className={'z-1'}
                                />
                            ),
                        }}
                    />
                )
            }
            searchInput={searchInput}
            onSearchInputChange={onSearchInputChange}
            searchLabel={t('label.search')}
            isMobile={isMobile}
        />
    );
};
